import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { emptyFn } from '../../utils/helper';
import { MenuItemContext } from './context';
import { consumeTheme } from '../../utils/theme';
var Menu = (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickedIds = [];
        _this.handleClick = function (e) {
            if (_this.clickedIds.length === 0) {
                return;
            }
            var id = _this.clickedIds.shift();
            _this.clickedIds = [];
            _this.props.onClick(id, e);
        };
        _this.handleItemClick = function (id) {
            _this.clickedIds.push(id);
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, itemStyle = _a.itemStyle;
            var classes = classNames(prefixCls, className);
            return (h(MenuItemContext.Provider, { value: { itemStyle: itemStyle, clickHandler: _this.handleItemClick } },
                h("ul", { className: classes, style: style, onClick: _this.handleClick }, children)));
        };
        return _this;
    }
    Menu.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Menu;
}(React.Component));
export default Menu;
Menu.defaultProps = {
    prefixCls: 'dui-m-menu',
    onClick: emptyFn
};
Menu.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    onClick: PropTypes.func,
    itemStyle: PropTypes.object
};
